import { ROUTE_GROUPS_ENUM } from 'routes/enums';
import { RouteGroupMapType } from 'routes/routeGroupMaps/types';

import defaultMap from './defaultMap';
import networksMap from './networksMap';
import clubsMap from './clubsMap';
import firmsMap from './firmsMap';
import adminsMap from './adminsMap';
import advisorsMap from './advisorsMap';
import afToolMap from './afTool';
import cmMap from './cmMap';
import guidesMap from './guidesMap';
import commissionTermsMap from './commissionTermsMap';
import userMap from './userMap';
import registrationMap from './registrationMap';

const map: RouteGroupMapType = new Map([
  [ROUTE_GROUPS_ENUM.DEFAULT, defaultMap],
  [ROUTE_GROUPS_ENUM.APPLICATIONS, new Map()], // to delete
  [ROUTE_GROUPS_ENUM.ESIS, new Map()], // to delete
  [ROUTE_GROUPS_ENUM.NETWORKS, networksMap],
  [ROUTE_GROUPS_ENUM.CLUBS, clubsMap],
  [ROUTE_GROUPS_ENUM.FIRMS, firmsMap],
  [ROUTE_GROUPS_ENUM.ADMINS, adminsMap],
  [ROUTE_GROUPS_ENUM.ADVISORS, advisorsMap],
  [ROUTE_GROUPS_ENUM.MBC, new Map()], // to delete
  [ROUTE_GROUPS_ENUM.FMA, new Map()], // to delete
  [ROUTE_GROUPS_ENUM.AF_TOOL, afToolMap],
  [ROUTE_GROUPS_ENUM.CM, cmMap],
  [ROUTE_GROUPS_ENUM.GUIDES, guidesMap],
  [ROUTE_GROUPS_ENUM.COMMISSION_TERMS, commissionTermsMap],
  [ROUTE_GROUPS_ENUM.QUOTE, new Map()], // to delete,
  [ROUTE_GROUPS_ENUM.USER, userMap],
  [ROUTE_GROUPS_ENUM.REGISTER, registrationMap],
]);

export default map;
